
const BASE_URL = 'https://ihbmop090b.execute-api.us-east-1.amazonaws.com/Dev';
const QUICK_RESPONSE = "https://90jhybz685.execute-api.us-east-1.amazonaws.com/dev";
const OUTBOUND_QUEUE = "https://n9vlcexxx9.execute-api.us-east-1.amazonaws.com/dev";
const DOWNLOAD_URL = "https://nzql8i8mok.execute-api.us-east-1.amazonaws.com/Dev";
const Extent_Feature_URL = "https://grj87qmm19.execute-api.us-east-1.amazonaws.com/Test";
const Updated_Feature_URL = "https://tygfe6u5hj.execute-api.us-west-2.amazonaws.com/test1"
export const endpoints = {
  fetchcaptcha: {
    fetchingcaptcha: `${BASE_URL}/CaptchaDisplay`
  },
  verifycaptcha: {
    verifyingcaptcha: `${BASE_URL}/CaptchaVerification`
  },
  mainforgot: {
    mainforgotpassword: `${BASE_URL}/ForgotPassword`
  },
  adminforgot: {
    adminforgotpassword: `${BASE_URL}/CognitoUpdate`
  },
  instanceDetails: {
    instancepage: `${BASE_URL}/InstanceUser`,
  },
  loginDetails: {
    loginpage: `${BASE_URL}/Main_Login_Details`,
    // displayInstance:`${BASE_URL}/Display_InstaceDetails`,

  },
  globalEnable:{
    emergencycloseEnableDisable:`${Updated_Feature_URL}/Emergency-DataPut`,
    emergencyCloseStatus:`${Updated_Feature_URL}/getEmergencyQueueStatus`,
    holidayEnableDisable:`${Updated_Feature_URL}/Holiday-DataPut`,
    holidayStatus:`${Updated_Feature_URL}/getHolidayQueueStatus`
  },
  instanceData: {
    fetchData: `${BASE_URL}/Display_InstaceDetails`, // Replace with actual endpoint
  },
  userDisplay: {
    userlist: `${BASE_URL}/ListingUsers`,
  },
  // signup: {
  //   signuplogin: `${Extent_Feature_URL}/SignUp`,
  // },
  signup: {
    signuplogin: `${Extent_Feature_URL}/SignUpDetails`,
  },
  // signupEmail: {
  //   signuploginEmail: `${Extent_Feature_URL}/SignUp_Email`,
  // },
  hoursDisplay: {
    displayhop: `${BASE_URL}/AdminUI_Listing_HOP_Timezones`,
  },
  addUser: {
    newuser: `${Extent_Feature_URL}/Users_Manually`,
  },
  userList: {
    listusers: `${Extent_Feature_URL}/List_Users`,
  },
  addRouting: {
    listrouting: `${Extent_Feature_URL}/ListingRoutingProfilesForUsers`,
  },
  addTimezones: {
    listtimezone: `${BASE_URL}/ListingTimezones`,
  },
  addRoute: {
    newRoute: `${Extent_Feature_URL}/RoutingProfiles`,
  },
  addhours: {
    addhop: `${Extent_Feature_URL}/HoursOfOperation`,
  },
  //  addQueue:
  //  {
  // addqueues:`${BASE_URL}/CreatingQueues`,
  //},
  displayroutes: {
    viewroutes: `${Extent_Feature_URL}/ListingRoutingProfiles`,
  },
  displayOutboundQueues: {
    displayQueues: `${Extent_Feature_URL}/ListingQueueForRoutingProfiles`
  },
  promptsDisplay: {
    promptlist: `${Extent_Feature_URL}/ListingPrompts`,
    editPrompt: `${Extent_Feature_URL}/Prompts`
  },
  promptPlay: {
    promptlist: `${Extent_Feature_URL}/Prompts`
  },
  s3Prompts: {
    createBucket: `${Extent_Feature_URL}/S3BucketCreationForPrompts`
  },
  phoneNumberDisplay: {
    viewPhoneNumber: `${BASE_URL}/ViewPhoneNumber`,
  },
  queuesDisplay: {
    viewQueues: `${Extent_Feature_URL}/ListingQueues`,
  },
  addQueuehop: {
    getAfterHours: `${Extent_Feature_URL}/List_HOP_For_Queues`
  },
  quickConnect: {
    //getQuickConnectNumber:`${QUICK_RESPONSE}/ListQuickconnects`,
    getQuickConnectName: `${Extent_Feature_URL}/List_QuickConnectsforQueues`
  },
  outbound: {
    CallerId: `${Extent_Feature_URL}/ListPhoneNumbers_For_Queues`
  },
  addQueue:
  {
    addqueues: `${Extent_Feature_URL}/Queues`,
  },
  upload: {
    s3Upload: `${Extent_Feature_URL}/Users_UploadingCSVFile_To_S3`
  },
  bulk: {
    BulkCsvUpload: `${Extent_Feature_URL}/Bulk_Users`
  },
  addhop: {
    timezoneslist: `${BASE_URL}/Listing_Timezones`
  },
  displayhoppage: {
    displayinghoplist: `${Extent_Feature_URL}/ListingHOPTimezones`
  },
  displaylisthop: {
    dipslayhopdata: `${Extent_Feature_URL}/List_HoursOfOperation`
  },
  downloadurl: {
    download: `${DOWNLOAD_URL}/rapidconnectbulkusers/Users.csv`
  },
  displaysecurityprofile: {
    securityprofile: `${Extent_Feature_URL}/SecurityProfiles`
  },
  displayquickConnects: {
    quickConnects: `${Extent_Feature_URL}/QuickConnects`
  },

  displayQueuelist: {
    quickQueue: `${Extent_Feature_URL}/List_Queues_For_QuickConnects`
  },
  displayPhoneNumberlist: {
    phoneNumber: `${Extent_Feature_URL}/ClaimPhoneNumbers`
  },
  displayContactflowlist: {
    flowlist: `${Extent_Feature_URL}/ListContactFlows_PhoneNumber`
  },
  displayAvailablephoneNumber: {
    phonelist: `${Extent_Feature_URL}/SearchAvailablePhoneNumbers`
  },
  displayflowassociate: {
    flowassociate: `${Extent_Feature_URL}/AssociatePhoneNumberToFlow`
  },
  phoneNumberRelease: {
    phoneRelease: `${Extent_Feature_URL}/ReleasePhoneNumbers`
  },

  listquickConnectUser: {
    listUsers: `${Extent_Feature_URL}/List_Users_For_QuickConnects`

  },
  instanceapihit: {
    instanceUser: `${Extent_Feature_URL}/CreateAuditLogTables`
  },
  adminLogs: {
    logsDashboard: `${Extent_Feature_URL}/DisplayAuditLogs`
  },
  voiceMailsDisplay: {
    voiceMailList: `${Extent_Feature_URL}/MailBoxDetails`,
    voiceMailAudioList:`${Extent_Feature_URL}/GetVoicemails`
  },

};
